import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';

import { SpinnerService } from './spinner.service';

@Component({
    selector: 'pcg-spinner'
    , templateUrl: './spinner.component.html'
    , styleUrls: ['./spinner.component.scss']
    , standalone: false
})
export class SpinnerComponent implements OnInit {

    public spinner = inject(SpinnerService);
    private ref = inject(ChangeDetectorRef);

	isLoading!: boolean;

	ngOnInit() {
		this.isLoading = false;
		this.spinner.loadingSource$.subscribe(isLoading => {
			this.isLoading = isLoading;
			this.ref.detectChanges();
		});
	}
}
